import { motion } from "framer-motion";
import { Award } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "At my old company it would have taken me 4 years to earn what I took home in the first 6 months at Agency HQ Commercial.",
    name: "Jack Barrett",
    role: "Agency HQ Commercial",
    img: "/testimonials/jack-barrett.png",
  },
  {
    quote:
      "Having dedicated years to the local franchise, I now have the freedom to work remotely, supported by a fully trained team. What an excellent regional model this is.",
    name: "Peter Sayers",
    role: "Agency HQ Wingham",
    img: "/testimonials/peter-sayers.png",
  },
];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="bg-[#111111] text-[#F9F8F6] px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="flex items-end justify-between flex-wrap gap-6 mb-16"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#F9F8F6]/50">Agents already keeping more</p>
          <div className="flex items-center gap-3 border border-[#F9F8F6]/20 px-4 py-3" data-testid="award-badge">
            <Award size={18} className="text-[#FF3B30]" />
            <span className="text-xs uppercase tracking-[0.2em]">REB Awards — Finalist</span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group"
              data-testid={`testimonial-${i + 1}`}
            >
              <div className="overflow-hidden border border-[#F9F8F6]/15">
                <img
                  src={t.img}
                  alt={t.quote}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                />
              </div>
              <figcaption className="mt-4 flex items-baseline gap-3 flex-wrap">
                <span className="text-sm font-semibold">{t.name}</span>
                <span className="text-xs text-[#F9F8F6]/50 uppercase tracking-[0.15em]">{t.role}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
